import React, { useState } from "react";
import { toast } from "react-toastify";
import { FaLinkedin, FaGithub, FaMedium, FaQuora, FaEnvelope, FaMapMarkerAlt, FaPhone } from "react-icons/fa";
import "./Contact.css";

const Contact = () => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await fetch("https://formspree.io/f/mojbavjn", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
      if (res.ok) {
        toast.success("Message sent — I'll reach out soon.");
        setFormData({ name: "", email: "", message: "" });
      } else {
        toast.error("Failed to send. Please try again.");
      }
    } catch (err) {
      toast.error("Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="sec" id="contact">
      <div className="wrap">
        <div className="sec-h"><span className="hash">##</span> contact / weights</div>
        <p className="contact-intro" data-aos="fade-up">
          Open to <b>ML Engineer</b>, <b>Data Scientist</b>, and <b>AI Engineer</b> roles. Have an opportunity? Let's connect.
        </p>

        <div className="contact-grid">
          <div className="contact-info" data-aos="fade-up">
            <div className="info-row"><FaEnvelope className="info-ic" /><div><span className="info-l">email</span><span className="info-v">ansaarbe125@gmail.com</span></div></div>
            <div className="info-row"><FaMapMarkerAlt className="info-ic" /><div><span className="info-l">location</span><span className="info-v">Thanjavur, Tamil Nadu · remote-ready</span></div></div>
            <div className="info-row"><FaPhone className="info-ic" /><div><span className="info-l">phone</span><span className="info-v">+91 82482 03655</span></div></div>

            <div className="info-social">
              <a href="https://www.linkedin.com/in/mohamed-ansaar-461b401b2/" target="_blank" rel="noreferrer"><FaLinkedin /></a>
              <a href="https://github.com/MDAnsaar25" target="_blank" rel="noreferrer"><FaGithub /></a>
              <a href="https://medium.com/@ansaarbe125" target="_blank" rel="noreferrer"><FaMedium /></a>
              <a href="https://www.quora.com/profile/Mohamed-Ansaar-8" target="_blank" rel="noreferrer"><FaQuora /></a>
            </div>
          </div>

          <form className="contact-form" onSubmit={handleSubmit} data-aos="fade-up">
            <label>name
              <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Your name" required />
            </label>
            <label>email
              <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="hello@example.com" required />
            </label>
            <label>message
              <textarea name="message" rows="5" value={formData.message} onChange={handleChange} placeholder="Hi Mohamed, I have an opportunity…" required />
            </label>
            <button type="submit" className="mc-btn" disabled={loading}>
              {loading ? "sending…" : "send message →"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;